module.exports = __webpack_public_path__ + "img/enterprise_setup_4.a00ada32.svg";